import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { FlexProps, MinWidthProps, ResponsiveValue } from 'styled-system';
import { flex, minWidth } from 'styled-system';

import FormSubmitButton from 'common/components/Form/FormSubmitButton';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { AddToCartProps } from '../components/types';

interface CtaButtonProps extends Pick<AddToCartProps, 'buttonKind' | 'isRounded' | 'withIcon'> {
  label: string;
  successLabel: string;
  isDisabled: boolean;
  isSuccess: boolean;
  isLoading?: boolean;
  className?: string;
  minWidth?: ResponsiveValue<string | number>;
}

const SPINNER_ICON_SIZE = [22, null, 20];
const SUCCESS_ICON_SIZE = [24, null, 22];

const UnstyledButton = styled(FormSubmitButton)<FlexProps & MinWidthProps>`
  ${flex};
  ${minWidth};
`;

const Button = (props: ComponentProps<typeof UnstyledButton>) => (
  <UnstyledButton
    mb="sp_0"
    flex={1}
    spinnerSize={SPINNER_ICON_SIZE}
    successButtonSize={SUCCESS_ICON_SIZE}
    {...props}
  />
);

const CtaButton = ({
  isLoading,
  isDisabled,
  isSuccess,
  label,
  successLabel,
  buttonKind,
  isRounded,
  withIcon,
  className,
  minWidth: minWidthValue = '146px',
}: CtaButtonProps) => {
  const { t } = useLocalization();

  return (
    <Button
      data-testid="add-to-cart-submit-btn"
      defaultButtonLabel={label}
      successButtonLabel={successLabel}
      isDisabled={isDisabled}
      isLoading={isLoading}
      isSuccess={isSuccess}
      kind={buttonKind}
      isRounded={isRounded}
      className={className}
      data-cnstrc-btn="add_to_cart"
      minWidth={minWidthValue}
      ariaLabel={t('add_to_cart')}
      {...(isRounded ? { py: 'sp_12' } : {})}
      {...(withIcon
        ? {
            iconName: 'cartWithPlus',
            iconSize: [24, null, null, 32],
            iconGap: 'sp_4',
          }
        : {})}
    />
  );
};

export default CtaButton;
